import { createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["ComboboxRoot"], _mergeProps(_ctx.$attrs, { class: "relative w-full" }), {
        default: _withCtx(() => [
            _createVNode($setup["ComboboxAnchorPrimitive"], {
                disabled: $props.disabled,
                readonly: $props.readonly,
                "has-error": $props.hasError
            }, _createSlots({
                default: _withCtx(() => [
                    _createVNode($setup["ComboboxInputPrimitive"], {
                        id: $props.id,
                        "display-value": $props.displayValue,
                        disabled: $props.disabled,
                        readonly: $props.readonly,
                        placeholder: $props.placeholder,
                        onInput: _cache[0] || (_cache[0] = ($event) => ($setup.emit('input', $event)))
                    }, null, 8 /* PROPS */, ["id", "display-value", "disabled", "readonly", "placeholder"])
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (_ctx.$slots.append)
                    ? {
                        name: "append",
                        fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "append")
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "readonly", "has-error"]),
            _createVNode($setup["ComboboxContentPrimitive"], null, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3 /* FORWARDED */
            })
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */));
}
